export interface RecommendationsChannelState {
  readonly items: ReadonlyArray<string>;
  readonly isFetching: boolean;
  /* recommendedViewMap prop is for remembering the order and hidden status of recs, for undo hide action.
   * List structure is not working here:
   *  - a user may hide multiple recs, and undo some of hidden recs with a different order.
   *  - it would be very hard to maintain the relative order of recs with a list.
   *
   * recommendedViewMap is a Map structure which keeps the insertion order,
   * and it can maintain the hidden status for each rec,m then we can easily render rec channel by filtering out hidden recs.
   */
  readonly recommendedViewMap?: Map<string, boolean>;
}

export interface RecommendationsShowMoreState {
  readonly similarUsers: number;
  readonly dataMonitoring: number;
  readonly popular: number;
}

export const initialRecommendationsChannelState: RecommendationsChannelState = {
  items: [],
  isFetching: true,
  recommendedViewMap: null
};

export const initialRecommendationsShowMoreState: RecommendationsShowMoreState = {
  similarUsers: 0,
  dataMonitoring: 0,
  popular: 0
};

export interface RecommendationsState {
  readonly recommendationsChannelState: RecommendationsChannelState;
  readonly recommendationsShowMoreState: RecommendationsShowMoreState;
  readonly dataChangeRadarUIEnabled: boolean;
}
